import { useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import HomePage from './pages/HomePage';
import PatternDetailPage from './pages/PatternDetailPage';
import AgentSystemPage from './pages/AgentSystemPage';
import LearningPathPage from './pages/LearningPathPage';
import PromptLibraryPage from './pages/PromptLibraryPage';
import PromptDetailPage from './pages/PromptDetailPage';

export default function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="site-wrapper">
      <Sidebar open={sidebarOpen} onToggle={() => setSidebarOpen(false)} />

      <main className="main-content">
        <div className="content-area" key={location.pathname}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/patterns/:id" element={<PatternDetailPage />} />
            <Route path="/agents" element={<AgentSystemPage />} />
            <Route path="/learning" element={<LearningPathPage />} />
            <Route path="/prompts" element={<PromptLibraryPage />} />
            <Route path="/prompts/:id" element={<PromptDetailPage />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}
